import EditorToolbar from "./editor-toolbar";
import SimpleToolbar from "./simple-toolbar";
export var BaseToolbar = {
  Editor: EditorToolbar,
  Simple: SimpleToolbar
};
export default BaseToolbar;
//# sourceMappingURL=index.js.map